import dayjs from "dayjs";

class Contenedor {
    constructor() {
        this.id = null;
        this.contenedor = '';
        this.concepto = '';
        this.naviera = '';
        this.preparador = '';
        this.comentarios = '';
        this.fecha_llegada_muelle = null;
        this.fecha_llegada = null;
        this.fecha_salida = null;
        this.fecha_aviso = null;
        this.es_exportacion = false;
        this.ejercicio = null;
        this.almacen = '';
        this.creado = null;
        this.modificado = null;
        this.documentos = [];
    }

    /**
     * Mapea los datos desde un objeto plano
     * @param {Object} data
     * @returns {Contenedor}
     */
    mapFromData(data) {
        this.id = data.id ?? null;
        this.contenedor = data.contenedor ?? '';
        this.concepto = data.concepto ?? '';
        this.naviera = data.naviera ?? '';
        this.preparador = data.preparador ?? '';
        this.comentarios = data.comentarios ?? '';
        this.fecha_llegada_muelle = data.fecha_llegada_muelle ? dayjs(data.fecha_llegada_muelle).toISOString() : null;
        this.fecha_llegada = data.fecha_llegada ? dayjs(data.fecha_llegada).toISOString() : null;
        this.fecha_salida = data.fecha_salida ? dayjs(data.fecha_salida).toISOString() : null;
        this.fecha_aviso = data.fecha_aviso ? dayjs(data.fecha_aviso).toISOString() : null;
        this.es_exportacion = data.es_exportacion ?? false;
        this.ejercicio = data.ejercicio ?? null;
        this.almacen = data.almacen ?? '';
        this.documentos = Array.isArray(data.documentos) ? data.documentos : [];


        return this;
    }

    /**
     * Generar un objecto de la clase
     * @returns {{es_exportacion: boolean, fecha_llegada: null, contenedor: string, creado: null, fecha_salida: null, almacen: string, modificado: null, id: null, fecha_aviso: null, ejercicio: null}}
     */
    toObject() {
        return {
            id: this.id,
            contenedor: this.contenedor,
            concepto: this.concepto,
            comentarios: this.comentarios,
            fecha_llegada_muelle: this.fecha_llegada_muelle,
            naviera: this.naviera,
            preparador: this.preparador,
            fecha_llegada: this.fecha_llegada,
            fecha_salida: this.fecha_salida,
            fecha_aviso: this.fecha_aviso,
            es_exportacion: this.es_exportacion,
            ejercicio: this.ejercicio,
            almacen: this.almacen,
            creado: this.creado,
            modificado: this.modificado,
            documentos: this.documentos
        };
    }

    /**
     * Alternativa estática para construir un contenedor desde datos externos.
     * @param {Object} data
     * @returns {Contenedor}
     */
    static from(data) {
        return new Contenedor().mapFromData(data);
    }
}

export default Contenedor;